import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import './Ingredient.css';
import { userActions } from '../_actions';


class Ingredient extends React.Component {
  
  constructor(props) {
    super(props);

    const { user } = this.props;

    this.state = {
      userModified: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        cabinet: user.cabinet,
        access_level: user.access_level,
        _id: user._id
      }
    };

  }
  
  removeFromCabinetChild(machine_name) {

    const { user } = this.props;

    const toDelete = new Set(machine_name);
    let cabinet = user.cabinet.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));
    let index = cabinet.indexOf(machine_name);    // <-- Not supported in <IE9
    if (index !== -1) {
      cabinet.splice(index, 1);
    }
    console.log("Does cabinet have this?", machine_name, cabinet);

    let userModifiedNew = {
      ...user,
      ['cabinet']: cabinet
    };
    console.log("removeFromCabinetChild Here ya go!", userModifiedNew);

    const { dispatch } = this.props;
    if (userModifiedNew.first_name) {
      console.log("Update this now mod!", userModifiedNew);
      dispatch(userActions.update(userModifiedNew));
    }
  }

  render() {

    const {user, match, ingredients, showCabinetRemove, showRecipeRemove, showEdit} = this.props;

    // BEGIN
    let machine_name = '';
    if (match.hasOwnProperty('params')) {
      machine_name = match.params.machine_name;
    } else {
      machine_name = match;
    }
    const isIngredient = p => p.machine_name === machine_name
    let ingredient = '';
    if (ingredients.items) {
      ingredient = ingredients.items.find(isIngredient)

    // END

    if (!ingredient) {
      // remove abandoned products from users cabinet
      this.removeFromCabinetChild(machine_name)
      return <div>The ingredient {machine_name} is no longer available, so has been removed from your cabinet.</div>
    }

    return (
      <div id={ingredient.machine_name + "_inner"}>
        <img class="card-img-top img-fluid" src={ingredient.img_url}/>
        <div class="card-body">
          <h5 class="card-title">
            {ingredient.name}
          </h5>
          {showCabinetRemove &&
          <button onClick={() => this.removeFromCabinetChild(ingredient.machine_name)}>Remove</button>
          }
          {showRecipeRemove &&
          <button onClick = {() => this.props.removeFromRecipe(ingredient.machine_name)}>Remove</button>
          }
          {showEdit && user.access_level > 5 &&
          <Link to={`/ingredient/${ingredient.machine_name}/edit`} className="btn btn-link">Edit</Link>
          }
          <p class="card-text" dangerouslySetInnerHTML={{__html: ingredient.container}}/>
          <div>{ingredient.category}</div>
        </div>
      </div>
    )
    } else {
      return (<div>Please navigate back to the home page.</div>)
    }
  }
}

function mapStateToProps(state) {
  const { authentication } = state;
  const { user } = authentication;
  return {
    user
  };
}

const connectedIngredient = connect(mapStateToProps)(Ingredient);
export { connectedIngredient as Ingredient };


// WEBPACK FOOTER //
// ./src/Ingredient/Ingredient.jsx